import Raven from 'raven-js';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';
export const getUpgradeProductFromUpgradePointApiName = (component, upgradePointApiName) => {
  const upgradeProduct = ApiNameToUpgradeProductMap[upgradePointApiName];
  if (upgradeProduct === undefined) {
    Raven.captureException(new Error(`Cannot find valid upgradeProduct for upgradePointApiName '${upgradePointApiName}' in component: ${component}`));
  }
  return upgradeProduct;
};
export const getStarterUpgradeProduct = ({
  productLine,
  tab
}) => {
  const isInApp = !tab;
  if (!isInApp) {
    return undefined;
  }
  const upgradeProductMaybe = productLine && UpgradeProducts[`${productLine}_STARTER`];
  return upgradeProductMaybe || UpgradeProducts.SUITE_STARTER;
};